import { useNavigate, useSearchParams } from "react-router-dom";
import { BillsListPage as BillsListPageView, type BillsListFilters } from "@/components/BillsListPage";

export function BillsListPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const states = searchParams.getAll("states");
  const defaultFilters: BillsListFilters = {
    states: states.length > 0 ? (states as BillsListFilters["states"]) : undefined,
    supplierId: searchParams.get("supplierId") ?? undefined,
    invoiceNumber: searchParams.get("invoiceNumber") ?? undefined,
    normalisedBillPoNumber: searchParams.get("billPoNumber") ?? undefined,
    dueDateFrom: searchParams.get("dueDateFrom") ?? undefined,
    dueDateTo: searchParams.get("dueDateTo") ?? undefined,
    tag: searchParams.get("tag") ?? undefined,
  };

  function handleFiltersChange(filters: BillsListFilters) {
    const next = new URLSearchParams();
    filters.states?.forEach((s) => next.append("states", s));
    if (filters.supplierId) next.set("supplierId", filters.supplierId);
    if (filters.invoiceNumber) next.set("invoiceNumber", filters.invoiceNumber);
    // Shared as ?billPoNumber=, the reader's word; the normalised filter is an internal detail.
    if (filters.normalisedBillPoNumber) next.set("billPoNumber", filters.normalisedBillPoNumber);
    if (filters.dueDateFrom) next.set("dueDateFrom", filters.dueDateFrom);
    if (filters.dueDateTo) next.set("dueDateTo", filters.dueDateTo);
    if (filters.tag) next.set("tag", filters.tag);
    setSearchParams(next, { replace: true });
  }

  return (
    <BillsListPageView
      onBillClick={(id) => navigate(`/bills/${id}`)}
      onMatchClick={(id) => navigate(`/bills/${id}/match`)}
      onPurchaseOrderClick={(id) => navigate(`/purchase-orders/${id}`)}
      onDeliveryNoteClick={(id) => navigate(`/delivery-notes/${id}`)}
      onUploadComplete={(id) => navigate(`/bills/${id}`)}
      defaultFilters={defaultFilters}
      onFiltersChange={handleFiltersChange}
    />
  );
}
